<template>
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// Tempo limite de inatividade: 10 minutos
const TEMPO_LIMITE = 10 * 60 * 1000
let timer

const fazerLogout = () => {
  // Remover dados salvos no login
  localStorage.removeItem('authToken')
  localStorage.removeItem('userTipo')

  // Redirecionar para login
  router.push('/')
}

const resetarTimer = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    fazerLogout()
  }, TEMPO_LIMITE)
}

onMounted(() => {
  // Iniciar temporizador
  resetarTimer()

  // Reinicia o timer ao interagir
  window.addEventListener('mousemove', resetarTimer)
  window.addEventListener('keypress', resetarTimer)
  window.addEventListener('click', resetarTimer)
  window.addEventListener('scroll', resetarTimer)
})

onUnmounted(() => {
  clearTimeout(timer)
  window.removeEventListener('mousemove', resetarTimer)
  window.removeEventListener('keypress', resetarTimer)
  window.removeEventListener('click', resetarTimer)
  window.removeEventListener('scroll', resetarTimer)
})
</script>

<style>
#app {
  font-family: 'BentonSans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
